// import { RichText } from '@frx/frx-components';
// import cn from 'classnames';

// import stjudelogo from '../../../assets/images/stjudelogo.jpg';
// import styles from './Header.module.scss';

import { Box, Flex } from '@chakra-ui/react';
import { HeaderLogo } from './HeaderLogo';
import { HeaderMenuItem } from './HeaderMenuItem';

import styles from './Header.module.scss';

// TODO: hard coded urls for now (marathon)
const contactUsUrl = `https://www.stjude.org/contact-us.html`;

export const Header = () => (
  <Box as="header" zIndex={10}>
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      w="100%"
      bg="white"
      boxShadow="base"
    >
      <Box p={4}>
        <HeaderLogo />
      </Box>

      <Box bg="white" className={styles.menuLinks} display="block" p={4} pr={6}>
        <HeaderMenuItem href={contactUsUrl}>Contact Us</HeaderMenuItem>
      </Box>
    </Flex>
  </Box>
);
